import { render, staticRenderFns } from "./go-top-button.vue?vue&type=template&id=49bd8bb0&lang=pug&"
import script from "./go-top-button.vue?vue&type=script&lang=js&"
export * from "./go-top-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports